export default __webpack_public_path__ + "media/Internet-of-Things.20e073bb.svg";